"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ModalTransitionContext = require("../../context/ModalTransitionContext");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  overflow: hidden;\n  position: absolute;\n  left: 0;\n  max-width: 100%;\n  visibility: hidden;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var InnerMeasure = _styledComponents.default.span.attrs({
  'aria-hidden': true
}).withConfig({
  displayName: "HiddenMeasure__InnerMeasure",
  componentId: "azp3uk-0"
})(_templateObject()); // We want to force popovers to stay closed, so we use ModalTransitionContext to tell popovers that
// they're in a transitioning modal. Weird but effective!


var hidePopoversContextValue = {
  transitioning: true
};
var HiddenMeasure = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(_ModalTransitionContext.ModalTransitionContextProvider, {
    value: hidePopoversContextValue
  }, _react.default.createElement(InnerMeasure, (0, _extends2.default)({}, props, {
    ref: ref
  })));
});
var _default = HiddenMeasure;
exports.default = _default;
module.exports = exports.default;